import { useEffect } from "react";

const MOBILE_BREAKPOINT = 991;

export default function useDrawerMenu(containerRef) {
  useEffect(() => {
    if (!containerRef.current) return;

    const buttons =
      containerRef.current.querySelectorAll(".menu-accrodion");

    const handleClick = (event) => {
      if (window.innerWidth > MOBILE_BREAKPOINT) return;

      const button = event.currentTarget;
      const sibling = button.nextElementSibling;
      if (!sibling) return;

      event.preventDefault();
      button.classList.toggle("active");

      if (button.classList.contains("active")) {
        sibling.style.maxHeight = "none";

        const height = sibling.scrollHeight;

        requestAnimationFrame(() => {
          sibling.style.maxHeight = `${height}px`;
        });
      } else {
        sibling.style.maxHeight = null;
      }
    };

    buttons.forEach((btn) =>
      btn.addEventListener("click", handleClick)
    );

    return () => {
      buttons.forEach((btn) =>
        btn.removeEventListener("click", handleClick)
      );
    };
  }, [containerRef]);
}
